module.exports = __webpack_public_path__ + "static/media/header.9c0370f0.png";